import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { Table, Data } from 'components/layout/Table'
import { leaders as leadersLayout } from 'constants/layout'
import { Export } from 'containers/misc'
import { RowSelectorTd, Status } from 'components/misc'
import { getActiveRole } from 'utils/token'
import config from 'config'
import { CONFIGURATION_KEYS, ROLES } from '../../../../constants/enums'
import { getLabels } from 'helpers/labelHelper'
import { initialize } from 'redux-form'
import { BulkAwardLeaders } from '../../../../containers/bulkChange'


export default class LeadersTable extends Component {
  static propTypes = {
    leaders: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    organizationHierarchyId: PropTypes.number,
    setLeadersParams: PropTypes.func,
    exportLeaders: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func,
    setLeaderSelectedTo: PropTypes.func.isRequired,
    selectableLeaderIds: PropTypes.array,
    areAllLeadersSelected: PropTypes.bool
  }

  static defaultProps = {
    permissions: {}
  }

  addLabelToFilter = label => {
    let initValues = []

    initValues.push({ value: label.id, label: label.name })
    this.props.dispatch(initialize(
        'leaders-filter',
        { 'labels_label_id@or' : initValues }
    ))
    this.props.setFilter(`labels.label.id=${label.id}`)
  }

  render() {
    const {
      leaders: { loading, list, offset, limit, pages, sort, selectedIds },
      selectableLeaderIds: selectableIds,
      setLeadersParams,
      organizationHierarchyId,
      permissions,
      activeOrganization,
      setCommonLimit,
      leaders,
      configuration,
      areAllLeadersSelected,
      setLeaderSelectedTo,
      bulkSelectLeaders,
      permissions: appPermission
    } = this.props

    const isContactLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableContactLabels.id}].booleanValue`)

    const safeSelectedIds = selectedIds || []

    const isLeader = getActiveRole(activeOrganization) === ROLES.LEADER.u

    const exportComponent = (
      <Export
        exportName="Leaders"
        toExport={this.props.exportLeaders}
        exportSchemeValue="leaders"
        count={leaders && leaders.count}
      />
    )

    const isLeaderRole = appPermission.activeRole === ROLES.LEADER.u

    return (
      <div>

        {(!isLeaderRole && isContactLabelsEnabled) && <BulkAwardLeaders
            selectedIds={safeSelectedIds}
        />}

        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={leadersLayout.tableHeaders({
            organizationHierarchyId,
            activeRole: getActiveRole(activeOrganization),
            isContactLabelsEnabled
          })}
          areAllSelected={areAllLeadersSelected ? true : undefined}
          bulkSelect={() => bulkSelectLeaders(safeSelectedIds, selectableIds)}
          setParams={setLeadersParams}
          permissions={permissions}
          exportComponent={exportComponent}
        >

          <Data>
            {list.map(({ id, globalId, person, organization, labels }) => (
              <tr key={id}>
                <RowSelectorTd
                    enabled={selectableIds && selectableIds.includes(id) ? true : undefined}
                    selected={selectedIds && selectedIds.includes(id) ? true : undefined}
                    setSelected={val => setLeaderSelectedTo(id, val)}
                />
                <td>
                  <Link to={{ pathname: `${config.publicPath}/leaders/${id}/detail` }}>
                    {globalId || id}
                  </Link>
                </td>
                <td>{get(person, 'firstName')}</td>
                <td>{get(person, 'lastName')}</td>
                <td>{get(person, 'email')}</td>
                <td>{get(organization, 'name')}</td>
                {permissions.isIf && (
                  <td>{get(organization, 'parentNAO.name') || '---'}</td>
                )}
                {isContactLabelsEnabled && !isLeader && <td>
                  {labels && getLabels(labels, this.addLabelToFilter)}
                </td> }
                <td>
                  <Status state={get(person, 'personState')} />
                </td>
              </tr>
            ))}
          </Data>
        </Table>
      </div>
    )
  }
}
